import { Home } from "@stories/pages/Home/Home";

export const HomeView = () => {
  return <Home />;
};
